import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Card, Avatar, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

//COMPONENTS
import CurrencyFormat from 'react-currency-format'

//REDUX
import {
  set_dialog_open,
  set_selected_product,
} from '../../redux/ducks/restaurantMenu'

const actionDispatch = (dispatch) => ({
  setDialogOpen: (isDialogOpen) => dispatch(set_dialog_open(isDialogOpen)),
  setSelectedProduct: (selectedProduct) =>
    dispatch(set_selected_product(selectedProduct)),
})

const MenuProduct = ({ product }) => {
  const { price, description, name } = product

  const { setDialogOpen, setSelectedProduct } = actionDispatch(useDispatch())

  const useStyles = makeStyles(() => ({
    avatarStyle: {
      width: '80px',
      height: '80px',
      marginRight: '1rem',
      backgroundColor: 'white',
    },
    boldText: {
      fontWeight: 'bold',
      margin: '0',
    },
    description: {
      margin: '0',
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      color: '#999',
    },
  }))
  const classes = useStyles()

  useEffect(() => {}, [])

  const handleProductSelection = () => {
    setDialogOpen(true)
    setSelectedProduct(product)
  }

  return (
    <Card onClick={handleProductSelection} style={{ cursor: 'pointer' }}>
      <Box display="flex" alignItems="center" p={1}>
        <Avatar className={classes.avatarStyle} src={product.image}>
          {''}
        </Avatar>

        <Box>
          <p
            className={classes.boldText}
            style={{
              margin: '0',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {name}
          </p>
          <p className={classes.description}>{description}</p>
          <CurrencyFormat
            value={price}
            className={classes.boldText}
            displayType="text"
            thousandSeparator
            prefix="$"
          />
        </Box>
      </Box>
    </Card>
  )
}

export default MenuProduct
